export default __webpack_public_path__ + "static/media/12.fcc40aa1.png";